<div class="aker-dark-theme context-toolbar">
  <div class="context-tools">
    @for (tool of tools$ | async; track tool) {
      @if (tool.visible$ | async) {
        <button class="aker-context-button" mat-raised-button (click)="tool.clickHandler()" [disabled]="tool.disabled$ | async">
          {{ tool.caption }}
        </button>
      }
    }
  </div>

  <div class="global-tools">
    @if (isOnline && displayProjectOverview$ | async) {
      <button
        class="aker-context-button"
        mat-raised-button
        (click)="goToProjectOverview()"
        appUserManual
        [userManualKey]="'project-over-button'"
      >
        <mat-icon>dashboard</mat-icon>
        <span>Project Overview</span>
      </button>
    }
    @if (isOnline && displayProjectSetup$ | async) {
      <button
        class="aker-context-button"
        mat-raised-button
        (click)="goToProjectSetup()"
        appUserManual
        [userManualKey]="'project-setup-button'"
      >
        <mat-icon>settings</mat-icon>
        <span>Setup</span>
      </button>
    }

    @if (isOnline) {
      <div class="search" appUserManual [userManualKey]="'context-toolbar-search'">
        <div class="search-box" role="search">
          <mat-icon class="search-trigger" tabindex="0" (click)="search()" (keyup.enter)="search()">search</mat-icon>
          <input type="text" [(ngModel)]="value" (keyup.enter)="search()" placeholder="Search" aria-label="Search" />
          @if (value) {
            <button type="button" class="clear-btn" aria-label="Clear search" (click)="clearSearch()">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
        @if (showCameraScannerOverlay) {
          <button mat-mini-fab color="primary" class="camera-scan-btn" (click)="openCameraScanner()" aria-label="Scan with camera">
            <mat-icon>photo_camera</mat-icon>
          </button>
        }
      </div>
    }
  </div>
</div>
